import { AfterViewInit, Component, OnDestroy, OnInit } from '@angular/core';
import { AsyncPipe } from '@angular/common';
import { ActivatedRoute, Params } from '@angular/router';
import { Store } from '@ngrx/store';
import { SnigelService } from '@uc/web/core';
import { Observable, Subscription } from 'rxjs';
import { fetchGuides } from '../../data-access/+state/guides.actions';
import {
	getStateCareerGuides,
	getStateCityGuides,
	getStateDegreeGuides,
} from '../../data-access/+state/guides.selectors';
import { SeoMetadataService } from '@uc/utilities';
import { GuideCategoryUrl, MainHeader } from '@uc/web/shared/data-models';
import { MainHeaderComponent } from '@web/shared/ui';
import { HeadingComponent } from '@uc/shared/ui';
import * as guidesCategoryProps from '../../static/guides-category.properties';
import { RecommendedUnisCarouselComponent } from '@uc/web/shared/feature/feature-recommended-universities';
import { StickyLeadBarRendererComponent } from '@web/shared/feature/feature-sticky-lead-bar';
import { CategoryHeaderNavigationComponent } from '../../components/category-header-navigation/category-header-navigation.component';
import { GuidesCardComponent } from '../../components/guides-card/guides-card.component';

@Component({
	selector: 'uc-guides-category',
	templateUrl: './guides-category.component.html',
	imports: [
		AsyncPipe,
		MainHeaderComponent,
		CategoryHeaderNavigationComponent,
		HeadingComponent,
		GuidesCardComponent,
		StickyLeadBarRendererComponent,
		RecommendedUnisCarouselComponent,
	],
})
export class GuidesCategoryComponent implements OnInit, OnDestroy, AfterViewInit {
	guides$!: Observable<any>;
	headerData!: MainHeader;
	headingContent!: { title: string; description: string } | undefined;
	subtitle!: string;
	categoryUrl!: GuideCategoryUrl;
	routeSub!: Subscription;

	constructor(
		private _store: Store,
		private _route: ActivatedRoute,
		private _seoSrv: SeoMetadataService,
		private _snigelSrv: SnigelService,
	) {}

	ngOnInit(): void {
		this._store.dispatch(fetchGuides());

		this.routeSub = this._route.params.subscribe((category: Params) => {
			this.categoryUrl = category['category'];
			this.selectCategoryGuide(this.categoryUrl);
		});
	}

	ngAfterViewInit(): void {
		this._snigelSrv.getAds([
			'incontent_1_dskt',
			'incontent_1_mob',
			'incontent_2_dskt',
			'incontent_2_mob',
		]);
	}

	updateSeo(title: string, description: string) {
		this._seoSrv.updateTitle(title);
		this._seoSrv.updateDescription(description);
	}

	getGuidesFromStore(category: string) {
		switch (category) {
			case 'career':
				this.guides$ = this._store.select(getStateCareerGuides);
				break;
			case 'city':
				this.guides$ = this._store.select(getStateCityGuides);
				break;
			default:
				this.guides$ = this._store.select(getStateDegreeGuides);
		}
	}

	selectCategoryGuide(category: GuideCategoryUrl) {
		const categoryData = guidesCategoryProps[category];
		if (!categoryData) return;
		this.headerData = categoryData.header;
		this.headingContent = categoryData.main;
		this.subtitle = categoryData.title;
		const { title, description } = categoryData.seo;
		this.updateSeo(title, description);

		this.getGuidesFromStore(category);
	}

	ngOnDestroy(): void {
		if (this.routeSub) this.routeSub.unsubscribe();
	}
}
